import {
  EXPORT_JSON_TEXT,
  IMPORT_JSON_TEXT,
  RESET_TO_DEFAULT_TEXT,
  RESET_TO_DEFAULT_AI_MODE_MESSAGE,
} from 'components/AiMode/constants';
import styles from './styles.module.scss';
import Separator from 'components/UI/Separator';
import { Button } from 'packages/radiant-react/button';
import { useStyleContext } from 'context/StyleContext';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';

const DataActions = ({
  openDownloadModal,
  openPasteModal,
  setMessage,
}: {
  openDownloadModal: () => void;
  openPasteModal: () => void;
  setMessage: (message: string) => void;
}) => {
  const { resetToDefault } = useStyleContext();

  const handleResetToDefault = () => {
    resetToDefault();
    setMessage(RESET_TO_DEFAULT_AI_MODE_MESSAGE);
  };

  return (
    <Vertical className={`${styles['dataActions-wrapper']}`}>
      <Horizontal className={`${styles['dataActions-container']}`} hAlignContent="right">
        <Horizontal className={`${styles['buttons-container']}`}>
          <Button
            onClick={handleResetToDefault}
            text={RESET_TO_DEFAULT_TEXT}
            type="tertiary"
            size="m"
            retainFocusOnClick={false}
            className={styles['buttons']}
            tooltip={RESET_TO_DEFAULT_TEXT}
          />
          <Separator
            orientation="vertical"
            color={'var(--rd-sys-color-border-subtle)'}
            style={{ top: '10px' }}
          />
          <Button
            onClick={openPasteModal}
            text={IMPORT_JSON_TEXT}
            type="tertiary"
            size="m"
            retainFocusOnClick={false}
          />
        </Horizontal>
        <Button
          onClick={openDownloadModal}
          text={EXPORT_JSON_TEXT}
          type="primary"
          size="m"
          retainFocusOnClick={false}
        />
      </Horizontal>
    </Vertical>
  );
};

export default DataActions;
